import React, { useEffect, useState } from "react";
import { axiosPost } from "../../../utils/AxiosApi";
import { postType, URL } from "../../../utils/Constants";
import { useARRCode } from "../context/ARRLevelContext";
import swal2 from "sweetalert2";
import swal from "sweetalert";
import { useDispatch } from "react-redux";
import { getNotices } from "../../../ducks/PostsDucks";

export const useRecruitmentByPeopleId = () => {
  const [data, setData] = useState(null);

  const selectRecruitmentByPeopleId = () => {
    const params = {
      peopleId: localStorage.getItem("peopleId"),
    };
    axiosPost(URL.selectRecruitmentByPeopleId, params, (response) => {
      if (response?.status === 200) {
        setData(response?.data?.data);
      }
    });
  };

  useEffect(() => {
    selectRecruitmentByPeopleId();
  }, []);

  return { data };
};

export const useFinalizedAssessmentYearLevel = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { arrLevel } = useARRCode();

  const selectFinalizedAssessmentYearLevel = () => {
    setLoading(true);
    axiosPost(
      URL.selectFinalizedAssessmentYearLevel,
      {
        assessmentModuleCode: arrLevel,
      },
      (response) => {
        if (response?.status === 200) {
          setData(response?.data?.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
      },
    );
  };

  useEffect(() => {
    selectFinalizedAssessmentYearLevel();
  }, [arrLevel]);

  return { data, loading };
};

export const useReportSetupTemplate = () => {
  const [data, setData] = useState();

  const getReportSetupTemplate = () => {
    axiosPost(URL.getReportSetupTemplate, {}, (response) => {
      if (response?.status === 200) {
        setData(response?.data?.data);
      }
    });
  };

  useEffect(() => {
    getReportSetupTemplate();
  }, []);

  return { data };
};

export const useSystemExamSubjects = () => {
  const [subjects, setSubjects] = useState([]);

  const selectSystemExamSubjects = (params) => {
    axiosPost(URL.selectSystemExamSubjects, params, (response) => {
      if (response?.status === 200) {
        setSubjects(response?.data?.data);
      }
    });
  };

  return { subjects, setSubjects, selectSystemExamSubjects };
};

export const useStudentWithAssessmentRoutine = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);

  const getStudentWithAssessmentRoutine = (params) => {
    setLoading(true);
    axiosPost(
      URL.getStudentWithAssessmentRoutine,
      params,
      (response) => {
        if (response?.status === 200) {
          setStudents(response?.data?.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
      },
    );
  };

  return { students, setStudents, loading, getStudentWithAssessmentRoutine };
};

export const useAssessmentReportValues = () => {
  const [reportValues, setReportValues] = useState([]);

  const getAssessmentReportValues = (params) => {
    axiosPost(URL.getAssessmentReportValues, params, (response) => {
      setReportValues(response?.data);
    });
  };

  return { reportValues, getAssessmentReportValues };
};

export const useReportSetupYearLevel = () => {
  const [reportSetups, setReportSetups] = useState([]);

  const selectByReportSetupYearLevel = (params) => {
    axiosPost(URL.selectByReportSetupYearLevel, params, (response) => {
      setReportSetups(response?.data);
    });
  };

  return { reportSetups, selectByReportSetupYearLevel };
};

export const useLoggedInRecruitmentId = () => {
  const [loggedInRecruitmentId, setLoggedInRecruimentId] = useState(null);

  const getLoggedInRecruitmentId = () => {
    const param = {
      peopleId: localStorage.getItem("peopleId"),
    };
    axiosPost(URL.selectRecruitmentByPeopleId, param, (response) => {
      if (response.status === 200) {
        setLoggedInRecruimentId(response?.data?.data);
      }
    });
  };

  useEffect(() => {
    getLoggedInRecruitmentId();
  }, []);

  return { loggedInRecruitmentId };
};

export const useReportPublish = () => {
  const dispatch = useDispatch();
  const [reportPublishing, setReportPublishing] = useState(false);

  const generateReportTemplate = (params) => {
    setReportPublishing(true);

    axiosPost(
      URL.generateReportTemplate,
      params,
      (response) => {
        if (response.status === 200) {
          const zipFolderName = response?.data?.data ?? "zipFolder.zip";
          const texts = `<p>Report has been successfully published<br>
          <button 
          class="tt-button tt-button-primary" 
          onclick="window.open('${URL.downloadReport + zipFolderName}', '_blank')">
          Download Files
                   </button>
                    </p>`;
          swal2.fire({
            title: "Success",
            html: texts,
            allowOutsideClick: false,
            closeOnClickOutside: false,
          });

          const param = {
            postType: postType.noticeCode,
            createdAt: new Date(),
            peopleId: localStorage.getItem("peopleId"),
          };

          dispatch(getNotices(param));
        } else {
          swal("Oops", "Error downloading");
        }
        setReportPublishing(false);
      },
      (failure) => {
        swal("Oops", failure.response.data.message);
        setReportPublishing(false);
      },
    );
  };

  const publishPdf = (params) => {
    setReportPublishing(true);
    axiosPost(
      URL.publishReport,
      params,
      (response) => {
        if (response.status === 200) {
          const zipFolderName = response?.data?.data ?? "zipFolder.zip";
          const texts = `<p>Report successfully published<br>
               <button 
               class="tt-button tt-button-primary" 
               onclick="window.open('${URL.downloadReport + zipFolderName}', '_blank')">
               Download Files
               </button>
                </p>`;

          swal2.fire({
            title: "Success",
            html: texts,
            allowOutsideClick: false,
            closeOnClickOutside: false,
          });

          let param = {
            postType: postType.noticeCode,
            createdAt: new Date(),
            peopleId: localStorage.getItem("peopleId"),
          };

          dispatch(getNotices(param));
        } else {
          swal("Oops", "Error downloading");
        }
        setReportPublishing(false);
      },
      (failure) => {
        setReportPublishing(false);
        swal("Oops", "Error publishing");
      },
    );
  };

  return { reportPublishing, generateReportTemplate, publishPdf };
};

export const useReportGeneration = () => {
  const [reportGenerating, setReportGenerating] = useState(false);

  const generateReportTemplate = (params) => {
    setReportGenerating(true);

    axiosPost(
      URL.generateReportTemplate,
      params,
      (response) => {
        if (response.status === 200) {
          const zipFolderName = response?.data?.data ?? "zipFolder.zip";
          const texts = `<p>Report has been successfully generated<br>
          <button 
                   class="tt-button tt-button-primary" 
                   onclick="window.open('${URL.downloadReport + zipFolderName}', '_blank')">
                   Download Files
                   </button>
                   </p>`;

          swal2.fire({
            title: "Success",
            html: texts,
            allowOutsideClick: false,
            closeOnClickOutside: false,
          });
        } else {
          swal("Oops", "Error downloading");
        }
        setReportGenerating(false);
      },
      (failure) => {
        swal(
          "Oops",
          failure?.response?.data?.message || "Failed to generate reports",
        );
        setReportGenerating(false);
      },
    );
  };

  const generateHtml = (params) => {
    setReportGenerating(true);
    axiosPost(
      URL.generateReport,
      params,
      (response) => {
        if (response.status === 200) {
          const zipFolderName = response?.data?.data ?? "zipFolder.zip";
          const texts = `<p>Report has been successfully generated<br>
                  <button 
                 class="tt-button tt-button-primary" 
                 onclick="window.open('${URL.downloadReport + zipFolderName}', '_blank')">
                 Download Files
                 </button>
                  </p>`;

          swal2.fire({
            title: "Success",
            html: texts,
            allowOutsideClick: false,
            closeOnClickOutside: false,
          });
        } else {
          swal("Oops", "Error downloading");
        }
        setReportGenerating(false);
      },
      (failure) => {
        swal(
          "Oops",
          failure?.response?.data?.message || "Failed to generate report",
        );
        setReportGenerating(false);
      },
    );
  };

  return { reportGenerating, generateReportTemplate, generateHtml };
};
